import React, { Component } from "react";
import { connect } from "react-redux";
import Checkbox from "../common/Checkbox";
import Style from "style-it";
import SearchField from "../common/SearchField";
import Scrollbar from "react-scrollbars-custom";
import isEqual from "react-fast-compare";

class CitySelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: {},
      search: "",
      isChecked: false
    };
  }

  componentDidMount() {
    this.initSelected();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.value, this.props.value)) {
      this.initSelected();
    }
    // When user cities load after mount, re-init if parent passed new defaults
    if (
      this.props.filterByUserCities &&
      !isEqual(prevProps.cities, this.props.cities) &&
      (!this.props.value || !this.props.value.length)
    ) {
      this.initSelected();
    }
  }

  initSelected = () => {
    const selectedIds = this.props.value || [];
    const list = {};

    selectedIds.forEach((id) => {
      list[id] = true;
    });

    const total = this.props.cities?.length || 0;

    this.setState({
      list,
      isChecked: total > 0 && total === selectedIds.length
    });
  };

  onChange = (e, city) => {
    let list = { ...this.state.list };

    if (e.target.checked) {
      list[city.id] = true;
    } else {
      delete list[city.id];
    }

    this.setState(
      {
        list,
        isChecked: this.props.cities?.length === Object.keys(list).length
      },
      () => {
        this.props.onChange &&
          this.props.onChange(Object.keys(this.state.list), "city");
      }
    );
  };

  toggleItems = (e) => {
    if (e.target.checked) {
      const list = {};
      this.props.cities?.forEach((c) => {
        list[c.id] = true;
      });

      this.setState(
        { list, isChecked: true },
        () =>
          this.props.onChange &&
          this.props.onChange(Object.keys(list), "city")
      );
    } else {
      this.setState(
        { list: {}, isChecked: false },
        () =>
          this.props.onChange &&
          this.props.onChange([], "city")
      );
    }
  };

  searchItem = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { cities = [] } = this.props;
    const { search, list } = this.state;

    const filteredCities = cities.filter((c) =>
      c.cityEn?.toLowerCase().includes(search.toLowerCase())
    );

    return (
      <Style>
        {`
        .selector-list li {
            margin-bottom: 6px;
        }
        .selector-list li > label {
            cursor: pointer;
            display: flex;
            align-items: center;
            padding: 2px 6px;
            border-radius: 4px;
        }
        .selector-list {
            padding: 0;
            margin: 0;
            list-style: none;
        }
        .selector-label {
            font-size: 12px;
            margin-left: 6px;
        }
        .selector-check {
            height: 26px;
            display: inline-flex;
            align-items: center;
        }
        .selector-count {
            padding: 5px 0;
            font-size: 12px;
        }
        `}
        <div>

          <div
            style={{
              marginBottom: 10,
              display: "flex",
              gap: "0.2rem",
              alignItems: "center"
            }}
          >
            <div style={{ flex: 0.55 }}>
              <SearchField
                label="Search Cities"
                type="search"
                placeholder="Search by name"
                value={search}
                onChange={this.searchItem}
                fullWidth
              />
            </div>

            <div style={{ flex: 0.45 }}>
              <Checkbox
                checked={this.state.isChecked}
                onChange={this.toggleItems}
                label="Select All"
              />
            </div>
          </div>

          <div className="selector-count">
            {Object.keys(list).length} Cities Selected
          </div>

          <Scrollbar style={{ height: 35 * (this.props.rows || 8) }}>
            {filteredCities.length ? (
              <ul className="selector-list">
                {filteredCities.map((row) => (
                  <li key={row.id}>
                    <label className={list[row.id] ? "active" : ""}>
                      <span className="selector-check">
                        <Checkbox
                          checked={list[row.id] || false}
                          onChange={(e) => this.onChange(e, row)}
                        />
                      </span>
                      <span className="selector-label">{row.cityEn}</span>
                    </label>
                  </li>
                ))}
              </ul>
            ) : (
              <div>No Cities Found</div>
            )}
          </Scrollbar>

        </div>
      </Style>
    );
  }
}

const mapState = (state, ownProps) => {
  const allCities = state.Cities.cities || [];
  const userCities = state.Cities.userCities || [];

  let cities = allCities;
  if (ownProps.filterByUserCities) {
    if (userCities.length) {
      const userIds = new Set(userCities.map((c) => String(c.id)));
      cities = allCities.length
        ? allCities.filter((c) => userIds.has(String(c.id)))
        : userCities;
    } else {
      cities = [];
    }
  }

  return {
    logInUser: state.logInUsers,
    cities,
    userCities,
  };
};

export default connect(mapState)(CitySelector);